import { ENV_VAR } from 'app/api';

const LOCALE_QUERY_STRING = 'locale';

const resolvePath = (path: string | string[] | undefined) => {
  switch (typeof path) {
    case 'string':
      return path;
    case 'object':
      return `/${path.join('/')}`;
    default:
      return '/';
  }
}

export const getSearchWithoutLocale = (search: string) => {
  const localeIndex = search.indexOf(LOCALE_QUERY_STRING);
  if (process.env.NODE_ENV === ENV_VAR.DEVELOPMENT && localeIndex !== -1) {
    const localeSearch = search.substr(localeIndex - 1, 10);
    return search.replace(localeSearch, '');
  }
  return search;
}

export default resolvePath;